(function() {
    angular
        .module("alertsModule")
        .controller("AlertDetailsTrackerController", AlertDetailsTrackerController)

    AlertDetailsTrackerController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "$stateParams",
        "$filter",
        "alertsService",
        "telemetryService",
        "userMessagingService",
        "DTOptionsBuilder",
        "DTColumnBuilder"
    ]

    function AlertDetailsTrackerController(
        $state,
        $rootScope,
        $scope,
        $stateParams,
        $filter,
        alertsService,
        telemetryService,
        userMessagingService,
        DTOptionsBuilder,
        DTColumnBuilder
    ){
        "use strict"

        $rootScope.title = "Alert Details | WANCO"

        $scope.alert = {}
        $scope.formData       = {}
        $scope.formData.fixed = false

        $scope.updateAlert = function() {
            alertsService.updateAlert(
                "Tracker",
                $stateParams.component_id,
                $stateParams.alert_id,
                angular.fromJson($scope.formData),
                function() {
                    //Success
                    alertsService.getAlertCount().then(function(data) {
                        $rootScope.alertCount = data.alerts
                    })

                    $state.go($state.$current, null, { reload: true })
                },
                function(error) {
                    //Failure
                    userMessagingService.error(error)
                }
            )
        }

        $scope.dtAlertOptions = DTOptionsBuilder.fromFnPromise(function() {
                return alertsService.getAlert("Tracker", $stateParams.component_id, $stateParams.alert_id).then(function(data) {

                    $scope.alert = data

                    var alertData = [
                        data
                    ]

                    if (data.fixed_by_user_id !== null) {
                        $scope.formData.fixed = true
                    }
                    $scope.formData.comments = data.comments || ""

                    return alertData
                })
            })
            .withOption("paging", false)
            .withOption("bInfo", false)
            .withOption("bFilter", false)
            .withOption("bAutoWidth", true)
            .withLanguage({
                "sEmptyTable":     "No data available in table",
                "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
                "sInfoEmpty":      "Showing 0 to 0 of 0",
                "sLoadingRecords": "Loading...",
                "sZeroRecords":    "No matching records found",
                "oPaginate": {
                    "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                    "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
                },
                "oAria": {
                    "sSortAscending":  ": activate to sort column ascending",
                    "sSortDescending": ": activate to sort column descending"
                }
            })
            .withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"pull-right text-right"fip><"clear">')
            .withOption("responsive", true)

        $scope.dtAlertColumns = [
            DTColumnBuilder.newColumn(null).withTitle("Created At")
                .renderWith(function(data, type, full, meta) {
                    const val = $rootScope.presentDateTime(data.created_at, "NumericLongDate", data.timezone_iana).split("@")
                    const d = val[0].trim()
                    let t = ""
                    if (val.length === 2) {
                        t = " <br/><span style='white-space: nowrap;'>" + val[1].trim() + "</span>"
                    }
                    return d + t
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Updated At")
                .renderWith(function(data, type, full, meta) {
                    const val = $rootScope.presentDateTime(data.updated_at, "NumericLongDate", data.timezone_iana).split("@")
                    const d = val[0].trim()
                    let t = ""
                    if (val.length === 2) {
                        t = " <br/><span style='white-space: nowrap;'>" + val[1].trim() + "</span>"
                    }
                    return d + t
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Details").renderWith(function(data, type, full, meta) {
                let ret = data.title
                if (data.description !== undefined && data.description !== null) {
                    ret += "<br />" + data.description
                }
                return ret
            }).notSortable(),
            DTColumnBuilder.newColumn("fixed_by_username").withTitle("Fixed By").notSortable(),
            DTColumnBuilder.newColumn("comments").withTitle("Comments").notSortable()
        ]

        $scope.dtTelemetryOptions = DTOptionsBuilder.fromFnPromise(function() {
                return telemetryService.getTelemetry("Tracker", $stateParams.component_id).then(function(data) {
                    var telemetryData = [
                        data
                    ]
                    return telemetryData
                })
            })
            .withOption("paging", false)
            .withOption("bInfo", false)
            .withOption("bFilter", false)
            .withOption("bAutoWidth", true)
            .withLanguage({
                "sEmptyTable":     "No data available in table",
                "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
                "sInfoEmpty":      "Showing 0 to 0 of 0",
                "sLoadingRecords": "Loading...",
                "sZeroRecords":    "No matching records found",
                "oPaginate": {
                    "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                    "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
                },
                "oAria": {
                    "sSortAscending":  ": activate to sort column ascending",
                    "sSortDescending": ": activate to sort column descending"
                }
            })
            .withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"pull-right text-right"fip><"clear">')
            .withOption("responsive", true)

        $scope.dtTelemetryColumns = [
            DTColumnBuilder.newColumn(null).withTitle("Date")
                .renderWith(function(data, type, full, meta) {
                    const val = $rootScope.presentDateTime(data.updated_at, "NumericLongDate", data.timezone_iana).split("@")
                    const d = val[0].trim()
                    let t = ""
                    if (val.length === 2) {
                        t = " <br/><span style='white-space: nowrap;'>" + val[1].trim() + "</span>"
                    }
                    return d + t
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("System Voltage")
                .renderWith(function(data, type, full, meta) {
                    if (data.hasOwnProperty("voltage_battery") && data.voltage_battery > 0) {
                        return $filter("number")((data.voltage_battery || "0.00"), 2) + " V"
                    }
                    return $filter("number")((data.voltage || "0.00"), 2) + " V"
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Lat")
                .renderWith(function(data, type, full, meta) {
                    return $filter("number")(data.gps.lat, 4)
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Lon")
                .renderWith(function(data, type, full, meta) {
                    return $filter("number")(data.gps.lon, 4)
                }).notSortable()
        ]
    }
})()
